import { Container } from '@mote/ui/components'
import styled from '@xstyled/styled-components'
import { CookieConsent } from './shared/CookieConsent'
import { Footer, Header } from './shared'

export const AuthLayout = ({ children }) => {
  return (
    <>
      <Root>
        <Header hideNavContent />
        <Container justifyContent='center' centered>
          {children}
        </Container>
        <Footer variant='minimal' />
      </Root>
      <CookieConsent />
    </>
  )
}

const Root = styled.div`
  display: grid;
  grid-template-rows: auto 1fr auto;
  grid-template-columns: 100%;
  width: 100%;
  min-height: 100%;
`
